<template>
  <div class="votreboutique">
    <div class="bar">BONNE NOUVELLE : Vous bénéficiez du fond de solidarité? le « click&collect » et la livraison ne sont pas comptabilisés dans le calcul de la perte de chiffre d’affaire !</div>
    <div class="head">
      <div class="left">
        <div class="title" data-sal="slide-up" data-sal-duration="400">Votre resto en quelques clics</div>
        <p data-sal="slide-up" data-sal-duration="400" data-sal-delay="300">Créez votre restaurant en quelques minutes, et vendez en ligne en toute simplicité</p>
        <button class="black" data-sal="slide-up" data-sal-duration="400" data-sal-delay="400"><a href="#decouvrez">Découvrez</a></button>

        <router-link data-sal="slide-up" data-sal-duration="400" data-sal-delay="450" v-if="!$store.state.user.logged" tag="button" @click.native="$store.dispatch('user/beforeLogin', 'boutique_creation')" :to="{ name: 'user_login' }">Je m’inscris !</router-link>
        <router-link data-sal="slide-up" data-sal-duration="400" data-sal-delay="450" v-else tag="button" :to="{ name: 'boutique_creation' }">Ajouter mon restaurant</router-link>
      </div>
      <div class="right">
      </div>
<!--      <div class="illu_block">-->
        <img data-sal="slide-up" data-sal-duration="600" data-sal-delay="0" class="illu" src="../../assets/img/illu/intro/chef2o.svg" alt="">
<!--      </div>-->
    </div>
    
<!--    <div class="pres_top" id="decouvrez">-->
<!--      <div class="title">Pourquoi monresto.click ?</div>-->
<!--      -->
<!--      <p>-->
<!--        Professionnels du secteur de l’hôtellerie/restauration et passionnés de nouvelles technologies, nous sommes avant tout conscients des difficultés économiques que traversent les restaurateurs actuellement.-->
<!--      </p>-->
<!--      -->
<!--      <div class="col">-->
<!--       <div class="e">-->
<!--         <b>Notre démarche est simple</b>-->
<!--          Mettre à profit une interface de vente en ligne efficace et facile d’accès pour tous les restaurateurs ou commerçants en appliquant des frais de commissions les plus bas du marché.-->
<!--       </div>-->
<!--       <div class="e">-->
<!--         <b>Aller à l’essentiel</b>-->
<!--         Nous avons conscience de la complexité que peut représenter la digitalisation de son activité, alors que vous soyez néophytes ou aguerris, la création de votre espace en ligne sur monresto.click se fera en un clin d’oeil et de manière intuitive.-->
<!--         Nous en avons fait notre priorité.-->
<!--       </div>-->
<!--&lt;!&ndash;     </div>&ndash;&gt;-->
<!--&lt;!&ndash;      <div class="col">&ndash;&gt;-->
<!--        <div class="e">-->
<!--          <b>Une alternative</b>-->
<!--          Les agglomérations de moins de 50k habitants sont peu desservies par les mastodontes du secteur en terme de restauration en ligne, rien que sur Cassis et la Ciotat, les restaurateurs présents se comptent sur les doigts d’une main.-->
<!--          Le constat est sans équivoque, les commissions opérées par les géants du secteur dissuadent fortement les restaurateurs de se digitaliser et de franchir le pas, nous n’avons ni la prétention ni le souhait de rivaliser avec des plateformes de renommées internationales, en revanche nous mettons tout en œuvre pour que le passage au numérique ne soit ni une source d’angoisse ni un sacrifice des marges pour le restaurateur ou le commerçant souhaitant franchir le pas.-->
<!--          Le capital risque est donc inexistant.-->
<!--        </div>-->

<!--        <div class="e">-->
<!--          <b>Une équipe dévouée</b>-->
<!--          Nous vous accompagnons dans votre démarche de A à Z-->
<!--          Que ce soit par prise de rendez-vous sur site, par Visio conférence, par mail ou encore par chat, nous vous garantissons une totale assistance des premiers pas.-->
<!--          Des conseils en esthétique ou en prise d’images peuvent être également proposés selon les cas.-->
<!--        </div>-->

<!--      </div>-->
<!--    </div>-->



    <div id="decouvrez" class="pres_col reverse one">
      <div class="left" data-sal="slide-up" data-sal-duration="600" data-sal-delay="100">
        <div class="title">Mettez votre restaurant en ligne et boostez votre activité !</div>
        <div class="description">
          Tenté de passer au digital mais peur de ne pas vous y retrouver ? <br>
          Pas convaincu par les commissions prises par les géants du secteur ? <br><br>

          Monresto.click est la solution alternative dans l'air du temps ! Simple, intuitive, efficace. <br>
          Coûts de commissionnement bas, inscription gratuite, optimisez votre chiffre d’affaire sans impacter votre rentabilité !

          <br><br>
          <savoir_plus :to="{ name: 'boutique_creation' }" button_text="Je m’inscris !" :login="true">
            L’inscription à MonResto.click se fait en quelques clics. <br>
            Les frais de commissionnements sont de 8%HT seulement (+0,25 cts par transaction). <br>
            Par exemple : Sur un ticket de vente à 30€ HT (soit 33€ TTC) nous prenons 2,89€ HT. <br><br>

            Votre espace pro vous donne la possibilité de mettre en avant vos produits et d’effectuer des promotions.
            <br>
            Vous disposez également d’un rapport de ventes avec courbes de progression et tableaux de bord journaliers.
            <br>
            <img style="width: 100%; margin-top: 16px;" src="../../assets/img/illu/resto/graph_compar.jpg" alt="">

          </savoir_plus>
        </div>
      </div>
      <div class="right">
        <img src="../../assets/img/illu/resto/tel.png" data-sal-duration="600" data-sal="slide-up" alt="">
      </div>
    </div>



    <div class="pres_col tv">
      <div class="left" data-sal="slide-up" data-sal-duration="600" data-sal-delay="100">
        <div class="title">Vous n’êtes pas à l’aise en informatique ?</div>
        <div class="description">
          Ça tombe bien, MonResto.click simplifie au maximum l’inscription des professionnels.
          <br><br>
          Vous êtes un restaurateur, un boulanger, un traiteur, un food truck, un fastfood, un snack…parfait ! Vous êtes certainement référencés sur google.
          <br><br>
          Recherchez votre établissement dans la barre de recherche et toutes vos informations seront directement importées sur notre plateforme : photos, adresse, numéro de téléphone…
          <br><br>
          Ajoutez vos produits et leurs prix.
          <br>
          Le tour est joué !

          <br><br>
          <savoir_plus :no_plus="true" :to="{ name: 'boutique_creation' }" button_text="Je m’inscris !" :login="true">
<!--            Vous créez votre établissement depuis votre ordinateur ou votre tablette en quelques clics sur https://monresto.click en rentrant vos coordonnées, votre localisation et vos produits (photo, description, tarif).-->
          </savoir_plus>
        </div>
      </div>
      <div class="right hidemob">
        <img data-sal="slide-up" data-sal-duration="600" src="../../assets/img/illu/resto/TV2.png" alt="">
      </div>
    </div>
    
    <div class="videos">
      <div class="video" data-sal="slide-up" data-sal-duration="600">
        <div class="ratio">
          <iframe class="player" frameborder="0" allowfullscreen="1" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" title="YouTube video player" width="640" height="360" src="https://www.youtube-nocookie.com/embed/ukRyfN00jMs?autoplay=0;loop=0;modestbranding=1;controls=1;showinfo=0;rel=0;enablejsapi=1;widgetid=1"></iframe>
        </div>
      </div>
      <div class="video" data-sal="slide-up" data-sal-duration="600" data-sal-delay="100">
        <div class="ratio">
          <iframe class="player" frameborder="0" allowfullscreen="1" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" title="YouTube video player" width="640" height="360" src="https://www.youtube-nocookie.com/embed/YiwAnKo2H2Q?autoplay=0;loop=0;modestbranding=1;controls=1;showinfo=0;rel=0;enablejsapi=1;widgetid=1"></iframe>
        </div>
      </div>
    </div>
    


    <div class="pres_col reverse three">
      <div class="left" data-sal="slide-up" data-sal-duration="600" data-sal-delay="100">
        <div class="title">Et maintenant ?</div>
        <div class="description">
          <b class="t"><span>1</span> Proposez votre ou vos modalités de retrait</b>
          <div class="paddingLeft">
            <b class="s">Le click&collect (principe de la «commande à emporter»)</b><br>
            Ici le client a déjà commandé en ligne et réglé l’addition, il vient récupérer ses produits sur des créneaux horaires prédéfinis et choisis, il optimise son temps et le vôtre, il apprécie la gratuité du service,  il n’a pas à faire la queue en caisse, il a plaisir à vous saluer ou à échanger.
            <br><br>
            <b class="s">Et/ou la livraison !</b> <br>
            Conservez votre indépendance et protéger votre image de marque en proposant vos propres livreurs ! <br>
            MonResto.click ne fournit pas de livreurs mais met à votre disposition une « interface livreurs » qui facilitera grandement le travail de ces derniers.
            <br>
            Si vous disposez de vos propres livreurs et que vous souhaitez proposer ce service à vos clients, activez l'option "livraison", délimitez vos zones de livraison et précisez vos conditions tarifaires.
          </div>
          <br>
          <b class="t"><span>2</span> Recevez votre première commande ! 🎉</b>
          <div class="paddingLeft">
          Une alerte sonore et visuelle apparait sur votre téléphone.
          <br>
          C’est parti !
            </div>
          <br>
          <b class="t"><span>3</span> Assurez le suivi sur votre interface</b>

          <div class="paddingLeft">
          Sur votre ordinateur, téléphone ou votre tablette. Validez vos commandes, visualisez vos ventes ou modifiez vos menus en toute simplicité.
          </div>
          <br>
          <savoir_plus :to="{ name: 'boutique_creation' }" button_text="Je m’inscris !" :login="true">
            90% des achats en ligne sont faits sur des marketplaces (rapport Magneto de 2019) <br>
            Mon Resto.click est une marketplace. <br>
            Votre inscription vous permet d’augmenter sensiblement votre visibilité et votre taux de transformation. <br>
            Vous avez l’opportunité de toucher une nouvelle cible et de la fidéliser. <br>
            Vous n’avez pas à investir personnellement dans des campagnes marketing et communication pour acquérir du trafic. <br>
            Vous n’êtes pas obligés de créer ou de maintenir un site marchand en parallèle (économie des coûts de création ou de maintenance) <br>
            Vous êtes libre de quitter la marketplace à tout moment, pour n’importe quels motifs et sans aucun frais.
           </savoir_plus>
        </div>
      </div>
      <div class="right">
        <img data-sal="slide-up" data-sal-duration="600" src="../../assets/img/illu/resto/commande.png" alt="">
      </div>
    </div>



    <div class="comment_ca_marche" data-sal="slide-up" data-sal-duration="600">
      <div class="title_col">Comment ça marche</div>
      <div class="cols">

        <div class="col">
          <div class="i">
            <div class="title">Clients</div>
            <div class="elem"> <span>1</span>Je choisis ma ville </div>
            <div class="elem"> <span>2</span>Je choisis mes articles </div>
            <div class="elem"> <span>3</span>Je choisis retrait ou livraison </div>
            <div class="elem"> <span>4</span>Je paye </div>
            <div class="elem"> <span>5</span>Je passe prendre ma commande ou je me fais livrer </div>
            <div class="elem"> <span>6</span>J’ai contribué à faire vivre un restaurateur local</div>
            <div class="elem"> <span>
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="24" height="24" viewBox="0 0 24 24"><path d="M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M7,9.5C7,8.7 7.7,8 8.5,8C9.3,8 10,8.7 10,9.5C10,10.3 9.3,11 8.5,11C7.7,11 7,10.3 7,9.5M12,17.23C10.25,17.23 8.71,16.5 7.81,15.42L9.23,14C9.68,14.72 10.75,15.23 12,15.23C13.25,15.23 14.32,14.72 14.77,14L16.19,15.42C15.29,16.5 13.75,17.23 12,17.23M15.5,11C14.7,11 14,10.3 14,9.5C14,8.7 14.7,8 15.5,8C16.3,8 17,8.7 17,9.5C17,10.3 16.3,11 15.5,11Z" /></svg>
            </span>Je me suis fait plaisir</div>
          </div>
        </div>
        <div class="col">
          <div class="i">
            <div class="title">Commerçants</div>
            <div class="elem"> <span>1</span>Je m’inscris </div>
            <div class="elem"> <span>2</span>Je crée mon restaurant </div>
            <div class="elem"> <span>3</span>Je crée mon menu </div>
            <div class="elem"> <span>4</span>Je vends </div>
            <div class="elem"> <span>
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="24" height="24" viewBox="0 0 24 24"><path d="M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M7,9.5C7,8.7 7.7,8 8.5,8C9.3,8 10,8.7 10,9.5C10,10.3 9.3,11 8.5,11C7.7,11 7,10.3 7,9.5M12,17.23C10.25,17.23 8.71,16.5 7.81,15.42L9.23,14C9.68,14.72 10.75,15.23 12,15.23C13.25,15.23 14.32,14.72 14.77,14L16.19,15.42C15.29,16.5 13.75,17.23 12,17.23M15.5,11C14.7,11 14,10.3 14,9.5C14,8.7 14.7,8 15.5,8C16.3,8 17,8.7 17,9.5C17,10.3 16.3,11 15.5,11Z" /></svg>
            </span>Je suis content </div>
          </div>
        </div>
      </div>

    </div>



<!--    <div class="pres_col abonnement small last" data-sal="fade" data-sal-duration="600">-->
<!--      <div class="left">-->
<!--        <div class="title">Soutien aux restaurateurs</div>-->
<!--        <div class="description">-->
<!--          <b class="boost">-->
<!--            <svg xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd"><path d="M6.178 4c-.914-1.493-2.944-3-6.178-3v-1c4.011 0 6.415 2.11 7.314 4h6.159l10.527 10.625-9.375 9.375-10.625-10.581v-6.242l-.282-.128c-1.043-.476-2.226-1.015-3.718-1.015v-1c1.641 0 2.943.564 4 1.044v-2.078h2.178zm10.944 9.109c-.415-.415-.865-.617-1.378-.617-.578 0-1.227.241-2.171.804-.682.41-1.118.584-1.456.584-.361 0-1.083-.408-.961-1.218.052-.345.25-.697.572-1.02.652-.651 1.544-.848 2.276-.106l.744-.744c-.476-.476-1.096-.792-1.761-.792-.566 0-1.125.227-1.663.677l-.626-.627-.698.699.653.652c-.569.826-.842 2.021.076 2.938 1.011 1.011 2.188.541 3.413-.232.6-.379 1.083-.563 1.475-.563.589 0 1.18.498 1.078 1.258-.052.386-.26.763-.621 1.122-.451.451-.904.679-1.347.679-.418 0-.747-.192-1.049-.462l-.739.739c.463.458 1.082.753 1.735.753.544 0 1.087-.201 1.612-.597l.54.538.697-.697-.52-.521c.743-.896 1.157-2.209.119-3.247zm-9.405-7.109c-.051.445-.215.83-.49 1.114-.387.398-.797.57-1.227.599.008.932.766 1.685 1.699 1.685.938 0 1.699-.761 1.699-1.699 0-.932-.751-1.69-1.681-1.699z"/></svg>-->
<!--            <span>L’abonnement mensuel est offert durant toute la période de fermeture administrative des commerces </span>-->
<!--          </b>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="right">-->
<!--        <pick_pack></pick_pack>-->
<!--      </div>-->
<!--    </div>-->
    
    <faq_restaurateur style="margin-top: 60px"></faq_restaurateur>


    <footer_b></footer_b>


  </div>
</template>

<script>

// import pick_pack from "@/components/global/pick_pack";
import savoir_plus from "@/components/global/savoir_plus";
import faq_restaurateur from "@/components/global/faq_restaurateur";

// import lax from 'lax.js'
// import lax from 'lax.js'

import sal from 'sal.js'
// @import '~sal.js/sal.css';
// import '@/node_modules/sal.js/dist/sal.css';

export default {
  name: "votreboutique",
  components: { savoir_plus, faq_restaurateur },
  methods: {
    // UpdateLax() {
    //   this.$lax.update(window.scrollY);
    //   window.requestAnimationFrame(this.UpdateLax);
    // }
  },
  created() {

  },
  mounted() {
  sal({
    threshold: 0.1,
    once: true
  })
    // this.$lax.init();
    //
    // this.$lax.addDriver("scrollY", function () {
    //   return window.scrollY;
    // });
    //
    // this.$lax.addElements(
    //     ".spinMe",
    //     {
    //       scrollY: {
    //         translateY: [0, -100]
    //       }
    //     },
    //     []
    // );
    
    // // Add animation bindings to elements
    // lax.addElements('.selector', {
    //   scrollY: {
    //     translateX: [
    //       ["elInY", "elCenterY", "elOutY"],
    //       [0, 'screenWidth/2', 'screenWidth'],
    //     ]
    //   }
    // })
  }
}
</script>

<style scoped>
div.head { position: relative; padding-top: 40px;
  display: flex; align-items: flex-end; justify-content: center; flex-direction: column; margin-bottom: 36px;
  /*background-color: #ee5522;*/
  /*background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 2000 1500'%3E%3Cdefs%3E%3CradialGradient id='a' gradientUnits='objectBoundingBox'%3E%3Cstop offset='0' stop-color='%23FB3'/%3E%3Cstop offset='1' stop-color='%23ee5522'/%3E%3C/radialGradient%3E%3ClinearGradient id='b' gradientUnits='userSpaceOnUse' x1='0' y1='750' x2='1550' y2='750'%3E%3Cstop offset='0' stop-color='%23f7882b'/%3E%3Cstop offset='1' stop-color='%23ee5522'/%3E%3C/linearGradient%3E%3Cpath id='s' fill='url(%23b)' d='M1549.2 51.6c-5.4 99.1-20.2 197.6-44.2 293.6c-24.1 96-57.4 189.4-99.3 278.6c-41.9 89.2-92.4 174.1-150.3 253.3c-58 79.2-123.4 152.6-195.1 219c-71.7 66.4-149.6 125.8-232.2 177.2c-82.7 51.4-170.1 94.7-260.7 129.1c-90.6 34.4-184.4 60-279.5 76.3C192.6 1495 96.1 1502 0 1500c96.1-2.1 191.8-13.3 285.4-33.6c93.6-20.2 185-49.5 272.5-87.2c87.6-37.7 171.3-83.8 249.6-137.3c78.4-53.5 151.5-114.5 217.9-181.7c66.5-67.2 126.4-140.7 178.6-218.9c52.3-78.3 96.9-161.4 133-247.9c36.1-86.5 63.8-176.2 82.6-267.6c18.8-91.4 28.6-184.4 29.6-277.4c0.3-27.6 23.2-48.7 50.8-48.4s49.5 21.8 49.2 49.5c0 0.7 0 1.3-0.1 2L1549.2 51.6z'/%3E%3Cg id='g'%3E%3Cuse href='%23s' transform='scale(0.12) rotate(60)'/%3E%3Cuse href='%23s' transform='scale(0.2) rotate(10)'/%3E%3Cuse href='%23s' transform='scale(0.25) rotate(40)'/%3E%3Cuse href='%23s' transform='scale(0.3) rotate(-20)'/%3E%3Cuse href='%23s' transform='scale(0.4) rotate(-30)'/%3E%3Cuse href='%23s' transform='scale(0.5) rotate(20)'/%3E%3Cuse href='%23s' transform='scale(0.6) rotate(60)'/%3E%3Cuse href='%23s' transform='scale(0.7) rotate(10)'/%3E%3Cuse href='%23s' transform='scale(0.835) rotate(-40)'/%3E%3Cuse href='%23s' transform='scale(0.9) rotate(40)'/%3E%3Cuse href='%23s' transform='scale(1.05) rotate(25)'/%3E%3Cuse href='%23s' transform='scale(1.2) rotate(8)'/%3E%3Cuse href='%23s' transform='scale(1.333) rotate(-60)'/%3E%3Cuse href='%23s' transform='scale(1.45) rotate(-30)'/%3E%3Cuse href='%23s' transform='scale(1.6) rotate(10)'/%3E%3C/g%3E%3C/defs%3E%3Cg %3E%3Cg transform=''%3E%3Ccircle fill='url(%23a)' r='3000'/%3E%3Cg opacity='0.5'%3E%3Ccircle fill='url(%23a)' r='2000'/%3E%3Ccircle fill='url(%23a)' r='1800'/%3E%3Ccircle fill='url(%23a)' r='1700'/%3E%3Ccircle fill='url(%23a)' r='1651'/%3E%3Ccircle fill='url(%23a)' r='1450'/%3E%3Ccircle fill='url(%23a)' r='1250'/%3E%3Ccircle fill='url(%23a)' r='1175'/%3E%3Ccircle fill='url(%23a)' r='900'/%3E%3Ccircle fill='url(%23a)' r='750'/%3E%3Ccircle fill='url(%23a)' r='500'/%3E%3Ccircle fill='url(%23a)' r='380'/%3E%3Ccircle fill='url(%23a)' r='250'/%3E%3C/g%3E%3Cg transform=''%3E%3Cuse href='%23g' transform='rotate(10)'/%3E%3Cuse href='%23g' transform='rotate(120)'/%3E%3Cuse href='%23g' transform='rotate(240)'/%3E%3C/g%3E%3Ccircle fill-opacity='0.24' fill='url(%23a)' r='3000'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");*/
  /*background-attachment: fixed;*/
  /*background-size: cover;*/
}
div.head .left { position: relative; z-index: 2;
  padding: 0 var(--padding) 14vw var(--padding); align-items: center; display: flex; flex-direction: column; text-align: center }
div.head .left .title{ font-weight: bold; font-size: 12vw; line-height: 12.2vw;  }
div.head .left p{ font-weight: normal; font-size: 6.3vw; line-height: 7.8vw; color: var(--black-sub); width: 80%; padding-bottom: 16px; }
div.head .left button { margin-right: 10px; border-radius: 50px; }
div.head .left button a { border: none }
div.head .left button{ background: var(--gris-button); color: var(--black-main) }
div.head .left button:last-child{ background: linear-gradient(90deg, #f23f3f 0%, #fb7f2a 100%) 0% 0%; color: #fff; margin-top: 16px; }
/*div.head .left button.orange { n }*/
div.head .right { width: 80%; top: -380px;  position: relative; }
div.head .right img { width: 130%; position: absolute; left: -120px; top: 0; }

/*div.head .illu_block { width: 100%; }*/
/*div.head .illu_block .illu {}*/

.pres_col { display: flex; flex-direction: column; padding: 20px 0 }
.pres_col .left { width: 100%; padding: 16px }
.pres_col .left .title { font-size: 38px; margin-bottom: 32px; font-weight: bold; }
.pres_col .left .description { font-weight: 400; font-size: 18px; line-height: 32px }
.pres_col .left .description b.s { font-weight: 700; color: var(--black-sub) }
.pres_col .left .description .paddingLeft { padding-left: 38px; font-size: 16px; line-height: 30px; }
.pres_col .left .description b.t { display: flex; padding-bottom: 10px; }
.pres_col .left .description b.t span { width: 30px; height: 30px; background: var(--gris); border-radius: 100%; display: flex; align-items: center; justify-content: center;
  margin-right: 8px; font-size: 18px; padding-top: 2px; flex: 0 0 auto;
}
/*.pres_col.small .left .description { font-size: 0.7vw; line-height: 1.4vw }*/
.pres_col .right { width: 100%; padding-top: 16px; }
.pres_col .right img { max-width: 100% }


.pres_top { padding: 42px 20px; font-weight: 400; font-size: 16px; line-height: 32px; background: #f5f5f5 }
.pres_top .col { display: flex; flex-direction: column }
.pres_top .title { font-size: 38px; margin-bottom: 32px; font-weight: bold; color: #333 }
.pres_top .e { margin-bottom: 16px; }
.pres_top b { display: block }

.videos { display: flex; justify-content: center; flex-direction: column; padding: 0 16px }
.videos .video { box-shadow: 3px 3px 20px 0 rgba(0,0,0,.10); width: 100%; margin-bottom: 16px; }
.videos .video .ratio {  position: relative; width: 100%; height: 0; padding-bottom: 56.25%; }
.videos .video iframe { position: absolute; top: 0; right: 0; bottom: 0; left: 0; width: 100%; height: 100%; }


.comment_ca_marche  { text-align: center; margin-top: 30px; padding: 48px 0 18px 0;
  background: transparent linear-gradient(30deg, #fa772d 0%, #ff8c85 100%) 0% 0% no-repeat padding-box;
}
.comment_ca_marche .cols { display: flex; flex-direction: column; justify-content: center; margin-top: 30px; }
.comment_ca_marche .col { display: flex; flex-direction: column; align-items: center; margin-bottom: 30px; width: 100%; }
.comment_ca_marche .col .i { width: 100%; }
.comment_ca_marche .title_col { font-size: 38px; margin-bottom: 22px; font-weight: bold; color: #fff; padding: 0 16px }
.comment_ca_marche .col .title { font-size: 28px; margin-bottom: 22px; font-weight: bold; color: #333 }
.comment_ca_marche .col .elem { min-height: 50px; width: 80%; display: flex; align-items: center; margin-bottom: 10px; font-size: 14px; font-weight: 400; text-align: left;
  background: #fff; box-shadow: rgba(33,33,33,.1) 0px 0px 20px 1px; padding: 8px 24px 8px 12px; border-radius: 40px; margin-left: auto; margin-right: auto;
}
/*.comment_ca_marche .col .elem:nth-child(odd) { transform: translateX(20px) }*/
/*.comment_ca_marche .col .elem:nth-child(even) { transform: translateX(-20px) }*/

/*.comment_ca_marche .col .elem:nth-child(3) { transform: translateX(10px) }*/
/*.comment_ca_marche .col .elem:nth-child(4) { transform: translateX(20px) }*/
/*.comment_ca_marche .col .elem:nth-child(5) { transform: translateX(30px) }*/
/*.comment_ca_marche .col .elem:nth-child(6) { transform: translateX(40px) }*/
/*.comment_ca_marche .col .elem:nth-child(7) { transform: translateX(50px) }*/
/*.comment_ca_marche .col .elem:nth-child(8) { transform: translateX(60px) }*/

.comment_ca_marche .col .elem span { display: inline-flex; width: 40px; height: 40px; align-items: center; justify-content: center; border: 2px solid #fff; border-radius: 100%;
  background: transparent linear-gradient(40deg, #f23f3f 0%, #fb7f2a 100%) 0% 0% no-repeat padding-box; color: #fff; box-shadow: rgba(33,33,33,.2) 0px 0px 6px 0px;
  margin-right: 16px; flex: 0 0 auto
}
.comment_ca_marche .col .elem:last-child { background: transparent linear-gradient(40deg, #f23f3f 0%, #fb7f2a 100%) 0% 0% no-repeat padding-box; color: #fff;
  border: 2px solid #fff;
}
.comment_ca_marche .col .elem:last-child span { background: #fff; color: #f23f3f }
.comment_ca_marche .col .elem:last-child span svg { fill: #f76334 }

.boost { border: 2px solid #fff; box-shadow: rgba(33,33,33,.1) 0 4px 24px 5px; display: flex; border-radius: 10px; padding: 16px; line-height: 24px; font-size: 19px;
  background: transparent linear-gradient(40deg, #f23f3f 0%, #fb7f2a 100%) 0% 0% no-repeat padding-box; color: #fff; font-weight: 400; margin-top: 10px;
}
.boost svg { flex: 0 0 auto; width: 35px; height: 40px; fill: #fff }


.bar { background: #d43838; color: #fff; text-align: center; display: flex; align-items: center; justify-content: center; font-size: 16px; line-height: 24px; padding: 12px 16px }

/*.pres_col .right .img { background: #eee; width: 100%; height: 0; padding-bottom: 100%; }*/

.pres_col.one .right{ overflow: hidden }
.pres_col.one .right img { position: relative; left: 4.4vw; }
.hidemob { display: none }

@keyframes ImgBounce {
  0% { transform: translateY(0) }
  100% { transform: translateY(-30px) }
}


@media only screen and (min-width: 800px) {
  .bar { padding: 6px 16px; min-height: 40px; }

  div.head .illu { position: absolute; bottom: 0; right: 0; width: 64.5vw; }
  /*div.head .illu_block .illu { width: 100%; }*/
  /*div.head .illu { position: absolute; bottom: 0; right: 0; width: 65.5vw; }*/
  
  .hidemob { display: block }

  div.head { flex-direction: row; min-height: 43vw; height: calc((var(--vh, 1vh) * 100) - 109px); padding-top: 0; margin-bottom: 4vw; max-height: 900px; }
  div.head .right { width: 45vw; padding-left: 12vw; }
  div.head .left { max-width: 35%; padding: 0; text-align: left; display: block; padding-bottom: 18.9vw; }
  div.head .left .title{ font-size: 4vw; line-height: 4.2vw; }
  div.head .left p{ font-size: 1.3vw; line-height: 1.8vw; padding: 0.1vw 0 0.8vw 0 }
  div.head .left button { margin-top: 0;}

  .pres_col { flex-direction: row; justify-content: center; width: 80%; margin: auto; padding: 60px 0 0 0 }
  .pres_col.last { padding-bottom: 40px; }
  .pres_col.reverse { flex-direction: row-reverse }
  .pres_col.reverse .left { padding-left: 100px; padding-right: 0; }
  .pres_col .left { padding: 40px 100px 80px 0 }
  .pres_col .left .title { font-size: 2.5vw; }
  .pres_col .left .description { font-size: 1.14vw; line-height: 1.8vw; width: 90%; }
  .pres_col .left .description .paddingLeft { padding-left: 2.1vw; font-size: 1vw; line-height: 1.7vw }
  .pres_col .right { width: 70%; }

  .pres_col.one .left { margin-top: 160px; }
  .pres_col.one .right img { position: relative; left: 0; }
  .pres_col.three .left { margin-top: 4.2vw; padding-left: 0; }
  
  .pres_col.tv { margin-right: 0; width: 100%; padding-left: 160px; }
  .pres_col.tv .left { width: 50%; padding-right: 0; }
  .pres_col.tv .left .description { font-size: 1vw; line-height: 1.6vw }


  .pres_col.small .left {width: 40%;}
  .pres_col.small .right {width: 35%;}


  .videos { flex-direction: row; padding: 0 160px 0 160px }
  .videos .video { width: 50%; margin-right: 36px; margin-bottom: 0; }
  .videos .video:last-child { margin-right: 0; }
  .videos .video .ratio {  position: relative; width: 100%; height: 0; padding-bottom: 56.255%; }
  .videos .video iframe { position: absolute; top: 0; right: 0; bottom: 0; left: 0; width: 100%; height: 100%; }
  
  
  .pres_top { padding: 64px 10% 36px 10% }
  .pres_top .col:first-child { margin-top: 32px; }
  .pres_top p { font-size: 18px; line-height: 28px; font-weight: 500; border-left: 1px solid var(--gris); color: var(--black-main); max-width: 800px; padding-bottom: 42px; margin: 0;
    padding-left: 16px;
  }
  .pres_top .col { flex-direction: row; flex-wrap: wrap } 
  .pres_top .col .e { padding-bottom: 36px; width: 50%; color: #716861; font-size: 16px; line-height: 32px; border-left: 1px solid var(--gris); padding-left: 16px; position: relative; }
  .pres_top .col .e:after { content: ''; top: 0; left: -1.5px; width: 2px; height: 30px; background: var(--orange); position: absolute; }
  .pres_top .col .e:nth-child(1n + 1) { padding-right: 48px; }
  .pres_top .col .e b { font-size: 24px; color: var(--black-main); font-weight: 600; flex: 0 0 auto; margin-bottom: 8px; }
  
  
  .pres_col.abonnement { flex-direction: column; align-items: center }
  .pres_col.abonnement .left { width: 100%; display: flex; flex-direction: column; align-items: center; padding: 0; margin-bottom: 16px; }
  .pres_col.abonnement .right { width: 100%; padding: 0 }
  .pres_col.abonnement .left .boost { width: 340px; margin: auto; }
  /*.pres_col.abonnement .left .boost { width: 400px; margin: auto; background: none; color: var(--black-main); box-shadow: none; padding: 0; margin-bottom: 20px; }*/
  /*.pres_col.abonnement .left .boost svg { fill: var(--orange); }*/
  .boost { }

  .comment_ca_marche .cols { flex-direction: row }
  .comment_ca_marche .title_col { font-size: 2.5vw; }
  .comment_ca_marche .col .elem { font-size: 20px }
  .comment_ca_marche .col { max-width: 550px }
  .comment_ca_marche .col:first-child {  }

}
@media only screen and (min-width: 1700px) {

  div.head .left { padding-bottom: 12.9vw; }

}



[data-sal]{transition-duration:.2s;transition-duration:var(--sal-duration,.2s);transition-delay:0s;transition-delay:var(--sal-delay,0s);transition-timing-function:ease;transition-timing-function:var(--sal-easing,ease)}[data-sal][data-sal-duration="200"]{transition-duration:.2s}[data-sal][data-sal-duration="250"]{transition-duration:.25s}[data-sal][data-sal-duration="300"]{transition-duration:.3s}[data-sal][data-sal-duration="350"]{transition-duration:.35s}[data-sal][data-sal-duration="400"]{transition-duration:.4s}[data-sal][data-sal-duration="450"]{transition-duration:.45s}[data-sal][data-sal-duration="500"]{transition-duration:.5s}[data-sal][data-sal-duration="550"]{transition-duration:.55s}[data-sal][data-sal-duration="600"]{transition-duration:.6s}[data-sal][data-sal-duration="650"]{transition-duration:.65s}[data-sal][data-sal-duration="700"]{transition-duration:.7s}[data-sal][data-sal-duration="750"]{transition-duration:.75s}[data-sal][data-sal-duration="800"]{transition-duration:.8s}[data-sal][data-sal-duration="850"]{transition-duration:.85s}[data-sal][data-sal-duration="900"]{transition-duration:.9s}[data-sal][data-sal-duration="950"]{transition-duration:.95s}[data-sal][data-sal-duration="1000"]{transition-duration:1s}[data-sal][data-sal-duration="1050"]{transition-duration:1.05s}[data-sal][data-sal-duration="1100"]{transition-duration:1.1s}[data-sal][data-sal-duration="1150"]{transition-duration:1.15s}[data-sal][data-sal-duration="1200"]{transition-duration:1.2s}[data-sal][data-sal-duration="1250"]{transition-duration:1.25s}[data-sal][data-sal-duration="1300"]{transition-duration:1.3s}[data-sal][data-sal-duration="1350"]{transition-duration:1.35s}[data-sal][data-sal-duration="1400"]{transition-duration:1.4s}[data-sal][data-sal-duration="1450"]{transition-duration:1.45s}[data-sal][data-sal-duration="1500"]{transition-duration:1.5s}[data-sal][data-sal-duration="1550"]{transition-duration:1.55s}[data-sal][data-sal-duration="1600"]{transition-duration:1.6s}[data-sal][data-sal-duration="1650"]{transition-duration:1.65s}[data-sal][data-sal-duration="1700"]{transition-duration:1.7s}[data-sal][data-sal-duration="1750"]{transition-duration:1.75s}[data-sal][data-sal-duration="1800"]{transition-duration:1.8s}[data-sal][data-sal-duration="1850"]{transition-duration:1.85s}[data-sal][data-sal-duration="1900"]{transition-duration:1.9s}[data-sal][data-sal-duration="1950"]{transition-duration:1.95s}[data-sal][data-sal-duration="2000"]{transition-duration:2s}[data-sal][data-sal-delay="50"]{transition-delay:.05s}[data-sal][data-sal-delay="100"]{transition-delay:.1s}[data-sal][data-sal-delay="150"]{transition-delay:.15s}[data-sal][data-sal-delay="200"]{transition-delay:.2s}[data-sal][data-sal-delay="250"]{transition-delay:.25s}[data-sal][data-sal-delay="300"]{transition-delay:.3s}[data-sal][data-sal-delay="350"]{transition-delay:.35s}[data-sal][data-sal-delay="400"]{transition-delay:.4s}[data-sal][data-sal-delay="450"]{transition-delay:.45s}[data-sal][data-sal-delay="500"]{transition-delay:.5s}[data-sal][data-sal-delay="550"]{transition-delay:.55s}[data-sal][data-sal-delay="600"]{transition-delay:.6s}[data-sal][data-sal-delay="650"]{transition-delay:.65s}[data-sal][data-sal-delay="700"]{transition-delay:.7s}[data-sal][data-sal-delay="750"]{transition-delay:.75s}[data-sal][data-sal-delay="800"]{transition-delay:.8s}[data-sal][data-sal-delay="850"]{transition-delay:.85s}[data-sal][data-sal-delay="900"]{transition-delay:.9s}[data-sal][data-sal-delay="950"]{transition-delay:.95s}[data-sal][data-sal-delay="1000"]{transition-delay:1s}[data-sal][data-sal-easing=linear]{transition-timing-function:linear}[data-sal][data-sal-easing=ease]{transition-timing-function:ease}[data-sal][data-sal-easing=ease-in]{transition-timing-function:ease-in}[data-sal][data-sal-easing=ease-out]{transition-timing-function:ease-out}[data-sal][data-sal-easing=ease-in-out]{transition-timing-function:ease-in-out}[data-sal][data-sal-easing=ease-in-cubic]{transition-timing-function:cubic-bezier(.55,.055,.675,.19)}[data-sal][data-sal-easing=ease-out-cubic]{transition-timing-function:cubic-bezier(.215,.61,.355,1)}[data-sal][data-sal-easing=ease-in-out-cubic]{transition-timing-function:cubic-bezier(.645,.045,.355,1)}[data-sal][data-sal-easing=ease-in-circ]{transition-timing-function:cubic-bezier(.6,.04,.98,.335)}[data-sal][data-sal-easing=ease-out-circ]{transition-timing-function:cubic-bezier(.075,.82,.165,1)}[data-sal][data-sal-easing=ease-in-out-circ]{transition-timing-function:cubic-bezier(.785,.135,.15,.86)}[data-sal][data-sal-easing=ease-in-expo]{transition-timing-function:cubic-bezier(.95,.05,.795,.035)}[data-sal][data-sal-easing=ease-out-expo]{transition-timing-function:cubic-bezier(.19,1,.22,1)}[data-sal][data-sal-easing=ease-in-out-expo]{transition-timing-function:cubic-bezier(1,0,0,1)}[data-sal][data-sal-easing=ease-in-quad]{transition-timing-function:cubic-bezier(.55,.085,.68,.53)}[data-sal][data-sal-easing=ease-out-quad]{transition-timing-function:cubic-bezier(.25,.46,.45,.94)}[data-sal][data-sal-easing=ease-in-out-quad]{transition-timing-function:cubic-bezier(.455,.03,.515,.955)}[data-sal][data-sal-easing=ease-in-quart]{transition-timing-function:cubic-bezier(.895,.03,.685,.22)}[data-sal][data-sal-easing=ease-out-quart]{transition-timing-function:cubic-bezier(.165,.84,.44,1)}[data-sal][data-sal-easing=ease-in-out-quart]{transition-timing-function:cubic-bezier(.77,0,.175,1)}[data-sal][data-sal-easing=ease-in-quint]{transition-timing-function:cubic-bezier(.755,.05,.855,.06)}[data-sal][data-sal-easing=ease-out-quint]{transition-timing-function:cubic-bezier(.23,1,.32,1)}[data-sal][data-sal-easing=ease-in-out-quint]{transition-timing-function:cubic-bezier(.86,0,.07,1)}[data-sal][data-sal-easing=ease-in-sine]{transition-timing-function:cubic-bezier(.47,0,.745,.715)}[data-sal][data-sal-easing=ease-out-sine]{transition-timing-function:cubic-bezier(.39,.575,.565,1)}[data-sal][data-sal-easing=ease-in-out-sine]{transition-timing-function:cubic-bezier(.445,.05,.55,.95)}[data-sal][data-sal-easing=ease-in-back]{transition-timing-function:cubic-bezier(.6,-.28,.735,.045)}[data-sal][data-sal-easing=ease-out-back]{transition-timing-function:cubic-bezier(.175,.885,.32,1.275)}[data-sal][data-sal-easing=ease-in-out-back]{transition-timing-function:cubic-bezier(.68,-.55,.265,1.55)}[data-sal|=fade]{opacity:0;transition-property:opacity}[data-sal|=fade].sal-animate,body.sal-disabled [data-sal|=fade]{opacity:1}[data-sal|=slide]{opacity:0;transition-property:opacity,transform}[data-sal=slide-up]{transform:translateY(8%)}[data-sal=slide-down]{transform:translateY(-20%)}[data-sal=slide-left]{transform:translateX(20%)}[data-sal=slide-right]{transform:translateX(-20%)}[data-sal|=slide].sal-animate,body.sal-disabled [data-sal|=slide]{opacity:1;transform:none}[data-sal|=zoom]{opacity:0;transition-property:opacity,transform}[data-sal=zoom-in]{transform:scale(.5)}[data-sal=zoom-out]{transform:scale(1.1)}[data-sal|=zoom].sal-animate,body.sal-disabled [data-sal|=zoom]{opacity:1;transform:none}[data-sal|=flip]{-webkit-backface-visibility:hidden;backface-visibility:hidden;transition-property:transform}[data-sal=flip-left]{transform:perspective(2000px) rotateY(-91deg)}[data-sal=flip-right]{transform:perspective(2000px) rotateY(91deg)}[data-sal=flip-up]{transform:perspective(2000px) rotateX(-91deg)}[data-sal=flip-down]{transform:perspective(2000px) rotateX(91deg)}[data-sal|=flip].sal-animate,body.sal-disabled [data-sal|=flip]{transform:none}

/*# sourceMappingURL=sal.css.map*/







</style>